var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircle = function SvgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 280,
    height: 280,
    fill: "none",
    role: "presentation"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 140,
    fill: "#000",
    fillOpacity: 0.1
  })));
};
export default SvgCircle;